import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireManage } from '@/auth/require-manage'

// The builder edits the form, so it is a write route.
export const Route = createFileRoute('/_layout/feedback-forms/$formId/')({
  beforeLoad: ({ context }) => {
    requireManage(context.me, 'feedback-forms', redirect({ to: '/feedback-forms', replace: true }))
  },
})
